<template>
  <div class="not-found">
    <div class="container py-5 text-center">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card shadow">
            <div class="card-body p-5">
              <h1 class="display-1 text-muted">404</h1>
              <h2 class="mb-4">Page Not Found</h2>
              <p class="lead mb-4">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
              <router-link to="/" class="btn btn-primary">
                <i class="bi bi-house-door me-2"></i>Return to Home
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView'
}
</script>
